// 표준 스토리지 용량 옵션 정의
// ⚠️ [정책] 이 목록은 사용자 노출 용량 목록에 병합하지 않는다!
//    사용자에게는 관리자 설정(device_catalog.storageOptions)만 노출한다. (SSOT)
//    이 상수는 isStandard 메타데이터/표시 우선순위 계산 용도로만 사용된다.

/**
 * 🎯 표준 용량 옵션 정의 (참고용 메타데이터)
 */
export const STANDARD_STORAGE_OPTIONS = {
  smartphone: {
    // 🍎 iPhone 표준 용량 (업계 표준)
    iPhone: [
      '64GB',   // 구형 모델
      '128GB',  // 기본형 표준
      '256GB',  // 중급 표준  
      '512GB',  // 고급 표준
      '1TB'     // 최고급 표준
    ],
    
    // 🤖 Galaxy 스마트폰 표준 용량 (업계 표준)
    Samsung: [
      '128GB',  // 기본형 표준
      '256GB',  // 중급 표준
      '512GB',  // 고급 표준  
      '1TB'     // 최고급 표준
    ]
  },
  
  tablet: {
    // 🍎 iPad 표준 용량 (업계 표준)
    iPad: [
      '64GB',   // 기본형
      '128GB',  // 표준
      '256GB',  // 중급
      '512GB',  // 고급
      '1TB',    // 최고급
      '2TB'     // 프로급
    ],
    
    // 🤖 Galaxy Tab 표준 용량 (업계 표준)
    Galaxy: [
      '64GB',   // 기본형  
      '128GB',  // 표준
      '256GB',  // 중급
      '512GB',  // 고급
      '1TB'     // 최고급
    ]
  }
} as const;

/**
 * 🎨 용량별 UI 표시 우선순위
 * - 숫자가 낮을수록 먼저 표시
 */
export const STORAGE_DISPLAY_PRIORITY: Record<string, number> = {
  '64GB': 1,
  '128GB': 2, 
  '256GB': 3,
  '512GB': 4,
  '1TB': 5,
  '2TB': 6,
  // 기타 용량들은 숫자 추출해서 정렬
};

/**
 * 🎯 용량별 설명 텍스트
 */
export const STORAGE_DESCRIPTIONS: Record<string, string> = {
  '64GB': '기본 용량',
  '128GB': '표준 용량',
  '256GB': '권장 용량', 
  '512GB': '대용량',
  '1TB': '최고 용량',
  '2TB': '프로 용량'
};







